export const POMPEYO_BUSINESS_UNIT_ID = 2;
export const SALFA_BUSINESS_UNIT_ID = 3;
export const POMPEYO_POST_VENTA_BUSINESS_UNIT_ID = 5;
export const SALFA_RAC_EXT_BUSINESS_UNIT_ID = 33;
